<template>
  <!-- Build Checklist -->
  <div class="">
    <div style="text-align: center;" class="menu-label">
      <h4>Choose Category</h4>
    </div>
    <div class="ctg-div">
      <div class="categories" v-for="option in allMenuOptions" :key="option.id">
        <div @click="chooseCategory(option.name)" class="category">
          <li>
            {{ option.name }}
          </li>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus }               from "../../eventBus";
import {router}                   from '../../router/router'

export default {
  name: "SelectCategory",
  components: {},
  data() {
    return {
      currentCategory: '',
      categoryChosen: false,
    };
  },
  computed: mapGetters(["allMenuOptions"]),
  methods: {
    ...mapActions([
      "setPartAttribs",
      'setCurrentPartType',
    ]),
    chooseCategory(category) {
      console.log(category)
      var cat = category
      if (category == 'Power Supply'){
        cat = 'psu'
      }
      this.setCurrentPartType(cat)
      this.setPartAttribs()
      EventBus.$emit("chooseCategory", cat);
      this.currentCategory = cat;
      this.categoryChosen = true;
      console.log('category selected: ' + this.currentCategory)
      console.log("category pick emited");
       router.push({path: '/users/items-controller/items?type='+cat.toLowerCase()}).catch(()=>{});
    },
  },
};
</script>

<style scoped>
li {
  list-style-type: none;
  display: inline;
}
.is-active li {
  color:  #1997c6!important;
}
.container {
  text-align: center;
  margin-left: -12px !important;
  height: 100% !important;
  overflow: hidden;
  margin-top: 8px;
  color: rgb(178, 179, 180) !important;
}
.menu-label {
  border-bottom: 1px solid #434857;
  margin-bottom: 6px;
}
.menu-label h4 {
  font-size: 15pt;
  font-weight: normal;
  letter-spacing: 1px;
  color: #9198aa;
  text-transform: uppercase;
}
.menu-link {
  margin-top: 2px !important;
  color: #cfd2da;
  font-size: 12pt;
  font-weight: lighter;
}
.menu-link:hover {
  text-decoration: unset;
  color: unset;
  transform: scale(1.01);
}
.ctg-div {
  margin-top: 20px;
}
.categories {
  text-align: center;
  font-size: 14pt;
}
.category {
  margin-right: auto;
  margin-left: auto;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 6px;
  border: 2px solid #434857;
  max-width: 400px;
}
.category:hover {
  background-color: #1997c6;
  border: 2px solid #1997c6 !important;
  border: none;
  color: white;
  cursor: pointer;
  overflow: hidden;
  transition: 0.2s;
}
</style>
